<template>
	<div class="error-page-wrap">
		<header-component type="home" />
		<div>
			<div class="error-page-content">
				<img v-if="isMtsby" class="error-page-img" src="@/resources/images/404_mts.jpg" alt="Pomogai" />
				<img v-else class="error-page-img" src="@/resources/images/error.png" alt="Pomogai" width="414" height="193" />
				<p v-if="!isMtsby" class="error-page-sign">404 Error</p>
			</div>
			<div class="error-page-text-wrap">
				<h2 class="error-page-title">
					{{ isMtsby ? 'Похоже, вы свернули не туда' : 'Мяу! Похоже, мы свернули не туда' }}
				</h2>
				<p v-if="isMtsby" class="error-page-text">Сейчас всё поправим</p>
			</div>
		</div>
		<base-button
			@click="toMain"
			class="error-page-btn"
			:icon="isMtsby ? undefined : 'arrow'"
			:text="'На главную'"
			icon-position="left"
			:variant="isMtsby ? 'primary' : 'gradient'"
		/>
	</div>
</template>

<script setup lang="ts">
import HeaderComponent from '@/components/HeaderComponent.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import AppConfig from '@/config'
import { useRouter } from 'vue-router'

const router = useRouter()
const isMtsby = AppConfig.isMts

function toMain() {
	router.push('/')
}
</script>

<style lang="scss" scoped>
.error-page {
	&-sign {
		font: var(--font-display);
		color: var(--text-tertiary);
	}
	&-content {
		margin-top: 52px;
		@include flex-column-center;
	}
	&-img {
		margin-bottom: 20px;
	}
	&-title {
		font: var(--font-display);
		margin-bottom: 12px;
		@if $is-mts {
			color: var(--text-primary);
			text-align: center;
		}
	}
	&-text {
		font: var(--font-heading);
		margin-bottom: 12px;
		color: var(--text-secondary);
		@if $is-mts {
			font: var(--font-body-large);
			color: var(--text-secondary);
			text-align: center;
		}
	}
	&-text-wrap {
		width: 100%;
		max-width: 351px;
		text-align: center;
		margin: 0 auto;
	}
	&-wrap {
		height: calc(100svh - 106px);
		position: relative;
		@include flex-column-between;
		@if $is-mts {
			justify-content: flex-start;
		}
	}
	&-btn {
		position: relative;
		left: 0;
		right: 0;
		margin: 0 auto;
		max-width: 200px;
		@if $is-mts {
			margin: 40px auto 0;
			max-width: 245px;
		}
	}
}
</style>
